import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import { connect } from 'react-redux';
import BaseFeature from './BaseFeature';
import { TUNING_FACTOR } from '../../../../../../utils/constantFeatures';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { Trans } from 'react-i18next';

class TuningFactor extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            isEnabledLumen: this.props.properties[TUNING_FACTOR.reference] && this.props.properties[TUNING_FACTOR.reference].value !== "0",
            isEnabled: this.props.properties[TUNING_FACTOR.enable].value === "1" ? true : false,
            lastTref: this.isOn(this.props.properties[TUNING_FACTOR.reference]) ? this.props.properties[TUNING_FACTOR.reference].value : "0"
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEnableLumen = this.handleChangeEnableLumen.bind(this);
    }

    isOn(property) {
        if (!property) {
            return false;
        }
        else {
            return property.value !== undefined
                && property.value !== null
                && property.value !== '0';
        }
    }

    handleChange(propertyName, value) {
        const v = value;

        if (this.getCorrectPropertyName(propertyName) === TUNING_FACTOR.reference) {
            this.setState({ lastTref: value });
        }

        if (this.getCorrectPropertyName(propertyName) === TUNING_FACTOR.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
        this.props.handleChange(propertyName, v);
    }

    handleChangeEnableLumen(e) {
        const value = e.target.checked;

        if (value !== true) {
            this.props.handleChange(TUNING_FACTOR.reference, '0');
        }
        this.setState({
            isEnabledLumen: value
        });
    }

    renderTref(className) {
        var tfRef = this.props.properties[TUNING_FACTOR.reference];
        if (!this.state.isEnabledLumen) {
            className += 'card-none';
        }

        if (tfRef) {
            return (
                <div>
                    <Row style={{ margin: "1rem auto" }}>
                        <Col style={{ paddingLeft: "0" }}>
                            <Trans i18nKey="Set_Luminaire_reference_light_output" />
                        </Col>
                        <Col>
                            <Checkbox
                                disabled={!this.state.isEnabled}
                                checked={this.state.isEnabledLumen}
                                onChange={this.handleChangeEnableLumen}
                            />
                        </Col>
                    </Row>
                    <div className={className}>
                        <PropertyPicker
                            disabled={!this.state.isEnabled}
                            property={tfRef}
                            title={''}
                            measureUnit={<Trans i18nKey="Lumen" />}
                            min={tfRef.valueMeta.min}
                            max={tfRef.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                    </div>
                </div>)
        }
        else {
            return null
        }
    }

    render() {

        const tfEn = this.props.properties[TUNING_FACTOR.enable];
        const tfMin = this.props.properties[TUNING_FACTOR.minimum];
        const tfMax = this.props.properties[TUNING_FACTOR.maximum];
        const tfSet = this.props.properties[TUNING_FACTOR.level];
        const isEnabled = this.props.properties[TUNING_FACTOR.enable].value === "1" ? true : false;
        //const tfRef = this.props.properties['tf.ref'];

        let className = '';

        return (
            <div className="flex-row">
                <Card className={this.getClassName([tfEn])}>
                    <div className="card-header-feature">
                        <Trans i18nKey="Tuning_Factor" />
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertySwitch
                            property={tfEn}
                            title={tfEn.info.displayName}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>

                <Card className={this.getClassName([tfMin, tfMax])}>
                    <div className="card-header-feature">
                        <Trans i18nKey="Limits_and_Reference_Lumen" />
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertyPicker
                            disabled={!isEnabled}
                            property={tfMax}
                            title={<Trans i18nKey="Maximum_Limit" />}
                            measureUnit={'%'}
                            min={Math.max(tfMin.value, tfMax.valueMeta.min, tfSet.value)}
                            max={tfMax.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            disabled={!isEnabled}
                            property={tfMin}
                            title={<Trans i18nKey="Minimum_Limit" />}
                            measureUnit={'%'}
                            min={tfMin.valueMeta.min}
                            max={Math.min(tfMax.value, tfMin.valueMeta.max, tfSet.value)}
                            step={1}
                            handleChange={this.handleChange} />
                        {this.renderTref(className)}
                    </Card.Body>
                </Card>

                <Card className={this.getClassName([tfSet])}>
                    <div className="card-header-feature">
                        <Trans i18nKey="Tuning_Level" />
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', minWidth: "15rem" }}>
                        <PropertyPicker
                            disabled={!isEnabled}
                            property={tfSet}
                            title={tfSet.info.displayName}
                            measureUnit={'%'}
                            min={Math.max(tfMin.value, tfSet.valueMeta.min)}
                            max={Math.min(tfMax.value, tfSet.valueMeta.max)}
                            step={1}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TuningFactor);
